import { getStorage } from 'firebase/storage'
import { firebaseApp,nftsFirebaseStorageUrl } from './firebase'


export const firebaseStorage = getStorage(firebaseApp)
export const nftFirebaseStorage = getStorage(firebaseApp, nftsFirebaseStorageUrl)
